<label [for]="id" *ngIf="leftLabel">{{ label }}</label>
<div class="input-field"
     [class.ui-float-label]="floatLabel"
     [class.invalid]="hasError"
     [class.hasOther]="isOtherSelected() && hasInputForOther">
    <label *ngIf="topLabel" [for]="id" class="active">{{ label }}</label>
    <p-autoComplete [(ngModel)]="value"
                    #autoComplete
                    [suggestions]="suggestions"
                    (completeMethod)="search($event)"
                    [field]="displayField"
                    [size]="30"
                    [minLength]="0"
                    dataKey="id"
                    [appendTo]="appendTo"
                    [required]="required"
                    [placeholder]="emptyText"
                    [forceSelection]="true"
                    [disabled]="disabled"
                    (onSelect)="onItemSelect($event)"
                    (onClear)="onClear()"
                    [dropdown]="dropdown">
    </p-autoComplete>
    <app-input *ngIf="isOtherSelected() && hasInputForOther"
               [id]="id"
               [formControl]="form.controls.other"
               [placeholder]="otherPlaceholder">
    </app-input>
    <label *ngIf="floatLabel" [for]="id" class="dropdown-label active">{{ label }}</label>
    <app-form-error-list *ngIf="showErrors" [errorMap]="formControl.errors"></app-form-error-list>
</div>
